import { Toro } from '../common/enumerations';

export class StationWithDurationModel
{
    private _station: any;
    private _status: string;
    private _duration: number;
    private _timeStamp: Date;

    constructor(station: any)
    {
        this._timeStamp = new Date();
        this._station = station;
        this._status = station.Status;
        this._duration = station.SecondsRemaining;
    }

    public get Station(): any { return this._station; }

    public get Duration(): number { return this._duration; }

    public get TimeStamp(): Date { return this._timeStamp; }

    public get zoneRunningState(): Toro.ZoneRunningState
    {
        if (this._status.startsWith('Running'))
        {
            return Toro.ZoneRunningState.Watering;
        }
        else if (this._status === 'Soaking')
        {
            return Toro.ZoneRunningState.Soaking;
        }

        return Toro.ZoneRunningState.Idle;
    }

    public update(station: any)
    {
        // Only update info is the state status changes.
        if (station.Status !== this._status)
        {
            this._timeStamp = new Date();
            this._station = station;
            this._status = station.Status;
            this._duration = station.SecondsRemaining;
        }
    }
}
